import {Author} from './research-portal/full-asset-page/asset-model/asset-model-relations/author.interface';

export class FacetGroupConfig{
    state: string;
    valuesToDisplay: number;
    sortType: string;

    constructor(state, valuesToDisplay, sortType){
        this.state = state;
        this.valuesToDisplay = parseInt(valuesToDisplay);
        this.sortType = sortType;
    }
}

export class ActiveFacet {
    key: string;
    label: string;
    excluded: boolean;
    locked: boolean;

    constructor(key, label, excluded){
        this.key = key;
        this.label = label;
        this.excluded = excluded;
    }
}

export class MultiFacet {
    multiFacet: string;
    multiFacetGroupId: number;

    constructor(multiFacet, multiFacetGroupId){
        this.multiFacet = multiFacet;
        this.multiFacetGroupId = multiFacetGroupId;
    }

}

export class FacetValueForInterface {
    key: any;
    label: string;
    count: number;
    checked?: boolean;
    excluded?: boolean;
    from?: number;
    to?: number;

    constructor(key, label, count){
        this.key = key;
        this.label = label;
        this.count = count;
        this.checked = false;
        this.excluded = false;
    }

}
export class FacetGroupForInterface {
    key: string;
    label: string;
    items: FacetValueForInterface[];
    expanded: boolean;
    limit?: number;
    revealed?: boolean;
    selectable?: boolean;
    showSectionActions?: boolean;

    constructor(key, label){
        this.key = key;
        this.label = label;
        this.revealed = false;
        this.showSectionActions = false;
    }

    setItems(items: FacetValueForInterface[]){
        this.items = items;
    }

    setExpanded(expanded: string){
        if (expanded === 'expanded'){
            this.expanded = true;
        } else {
            this.expanded = false;
        }
    }

    setLimit(limit: number){
        this.limit = limit;
    }

}

export interface FacetValue {
    value: string;
    label: string;
    count: string;
}

export interface FacetGroup {
    name: string;
    values: FacetValue[];
}

export interface Asset {
    id: string;
    title: string;
    resourceType: string;
    resourceSubType?: string;
    publicationDetails: string;
    conferenceDetails: string;
    eventDetails: string;
    seriesDetails: string;
    etdDetails: string;
    date: string;
    description: string;
    creators: Author[];
    peerreview: boolean;
    openaccess: string;
    doi: string;
    thumbnail?: string;
    permalink: string;
    identifiers?: string;
}

export interface Doc {
    id: number;
}

export interface Info {
    totalResultsLocal: number;
    total: number;
    first: number;
    last: number;
}

export interface AssetsSearchResults {
    docs: Doc[];
    info: Info;
    assets: Asset[];
    facets: FacetGroup[];
}
